import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withErrorBoundary } from 'react-error-boundary';

import TabsMenu from './tabs_menu';
import ErrorBoundaryFallback from './error_boundary_fallback';

const { VC, ApplicationHelper } = window;

const ContentLayout = ({ showTabs, children }) => {
  useEffect(() => {
    // When a page with this content is rendered, we want to hide backbone content
    // And unrender it
    document.getElementById('backbone-contents').classList.add('hidden');
    if (VC.currentView) {
      VC.currentView.doUnRender();
      ApplicationHelper.cleanBodyViewClass();
    }
    // Clear out error page for non existing backbone route
    // or residual content left after previous backbone view
    document.getElementById('contents').innerHTML = '';

    return () => {
      document.getElementById('backbone-contents').classList.remove('hidden');
    };
  }, []);

  return (
    <div className="react-contents">
      {showTabs && <TabsMenu />}
      {children}
    </div>
  );
};

ContentLayout.propTypes = {
  showTabs: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ContentLayout.defaultProps = {
  showTabs: false,
};

export default withErrorBoundary(ContentLayout, {
  FallbackComponent: ErrorBoundaryFallback,
});
